export default {"src":"/_next/static/media/xlm.c03f3257.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};